import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import ProductForm from '../components/ProductForm';
import ProductDetailsModal from '../components/ProductDetailsModal';

function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const skipFirstSearchEffect = useRef(true);

  const fetchProducts = useCallback(async (searchTerm = '', options = {}) => {
    const { showLoading = false } = options;

    try {
      if (showLoading) {
        setLoading(true);
      } else {
        setSearching(true);
      }

      const response = await axios.get('/api/products', {
        params: { search: searchTerm }
      });
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      if (showLoading) {
        setLoading(false);
      } else {
        setSearching(false);
      }
    }
  }, []);

  useEffect(() => {
    fetchProducts('', { showLoading: true });
  }, [fetchProducts]);

  useEffect(() => {
    if (skipFirstSearchEffect.current) {
      skipFirstSearchEffect.current = false;
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      fetchProducts(search);
    }, 250);

    return () => clearTimeout(timeoutId);
  }, [search, fetchProducts]);

  const handleDelete = async (id) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa sản phẩm này?')) {
      try {
        await axios.delete(`/api/products/${id}`);
        fetchProducts(search);
      } catch (error) {
        console.error('Error deleting product:', error);
      }
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingId(null);
    fetchProducts(search);
  };

  const viewDetails = async (id) => {
    try {
      const response = await axios.get(`/api/products/${id}`);
      setSelectedProduct(response.data);
    } catch (error) {
      console.error('Error fetching product details:', error);
    }
  };

  const handleProductUpdated = (updatedProduct) => {
    setProducts((prevProducts) => prevProducts.map((product) => (
      product.id === updatedProduct.id
        ? { ...product, ...updatedProduct }
        : product
    )));
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '12px', flexWrap: 'wrap' }}>
        <div>
          <h2>Quản Lý Sản Phẩm</h2>
          <p>Nhập tên sản phẩm để tìm kiếm và xem giá sỉ từng mặt hàng.</p>
        </div>
        <button className="success" onClick={() => setShowForm(true)}>+ Thêm sản phẩm</button>
      </div>

      <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        <input
          type="text"
          placeholder="Tìm kiếm sản phẩm..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ padding: '10px 14px', width: '320px', maxWidth: '100%', borderRadius: '6px', border: '1px solid #ddd' }}
        />
        {searching && <span style={{ color: '#667085', fontSize: '14px' }}>Đang tìm...</span>}
      </div>

      {showForm && (
        <ProductForm productId={editingId} onClose={handleFormClose} />
      )}

      {selectedProduct && (
        <ProductDetailsModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
          onProductUpdated={handleProductUpdated}
        />
      )}

      {loading && products.length === 0 ? (
        <div className="loading">Đang tải sản phẩm...</div>
      ) : products.length === 0 ? (
        <div className="empty-state">Chưa có sản phẩm nào</div>
      ) : (
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Tên sản phẩm</th>
                <th>Giá nhập</th>
                <th>Giá bán lẻ</th>
                <th>Kho hàng</th>
                <th>Hành động</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product.id}>
                  <td>{product.name}</td>
                  <td>{product.purchase_price.toLocaleString()} ₫</td>
                  <td>{product.retail_price_70k.toLocaleString()} ₫</td>
                  <td>{product.quantity || 0} cái</td>
                  <td>
                    <button onClick={() => {
                      setEditingId(product.id);
                      setShowForm(true);
                    }}>
                      Sửa
                    </button>
                    <button onClick={() => viewDetails(product.id)} style={{ marginLeft: '5px' }}>Chi tiết</button>
                    <button className="danger" onClick={() => handleDelete(product.id)} style={{ marginLeft: '5px' }}>Xóa</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Products;
